
@switch (state) {
  <!-- LOADING: state === null -->
  @case (null) {
    <div class="text-center">
      <output class="spinner-border c-primary">
        <span class="visually-hidden">{{ loadingText }}</span>
      </output>
    </div>
    <p class="legenda-spinner">{{ loadingText }}</p>
  }
  <!-- ERRO: state === false -->
  @case (false) {
    <div class="text-center">
      <img [src]="errorImg" alt="erro na consulta" width="230px">
      <p class="legenda-erro">{{ errorText }}</p>
    </div>
  }
  <!-- VAZIO: state === undefined -->
  @default {
    @if (state === undefined) {
      <div class="text-center">
        <img [src]="emptyImg" alt="nenhum resultado encontrado" width="230px">
        <p class="legenda-vazio">{{ emptyText }}</p>
      </div>
    } @else {
      <ng-content></ng-content>
    }
  }
}
